import { render, staticRenderFns } from "./FastDetail.vue?vue&type=template&id=0b67762a&scoped=true&"
import script from "./FastDetail.vue?vue&type=script&lang=js&"
export * from "./FastDetail.vue?vue&type=script&lang=js&"
import style0 from "./FastDetail.vue?vue&type=style&index=0&id=0b67762a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b67762a",
  null
  
)

export default component.exports